import React, {useEffect, useState} from 'react';
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
import passwordValidator from 'password-validator';
import {Actions as PAYSLIPSAMPLEACTIONS} from '../../store/actions/payslipSampleActions';
import {Actions as CREATEACCOUNTACTIONS} from '../../store/actions/createAccountActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import * as yup from 'yup';

// Create a schema
var schema = new passwordValidator();

// Add properties to it
schema
.is().min(8)                                    // Minimum length 8
.is().max(100)                                  // Maximum length 100
.has().uppercase()                              // Must have uppercase letters
.has().lowercase()                              // Must have lowercase letters
.has().digits(1)                                // Must have at least 1 digits
.has().not().spaces()                           // Should not have spaces
// .is().not().oneOf(['Passw0rd', 'Password123']); // Blacklist these values


let numSchema = yup.object().shape({
  hours: yup.number().positive().max(173.33),
});

let emailSchema = yup.object().shape({
  email: yup.string().required().email(),
});

function PayslipSampleGenerator({
  generateSamplePayslip,
  clearSamplePayslip,

  creatingPayslip,
  payslipDownloadLink,

  country,
  saveLead,
  addTag,
}) {

  const currencySign = country && country == "UK" ? '£' : '€'

  const [leaveErrorText, setLeaveErrorText] = useState("");
  const [emailErrorText, setEmailErrorText] = useState("");

  const [data, setData] = useState({
    salary: "10/hr",
    hourlyRate: 10,
    workedHours: 180,
    basicHours: 165.33,
    basicHoursValue: 1733.30,
    leaveHours: 8,
    vacationLeaveValue: 80,
    overtimeHours: 14.67,
    overtimeValue: 220.05,
    gross: 2083.35,
    performanceBonus: 50,
    consent: false,
    email: "",
  });


  const handleChange = (event) => {

    // clear
    payslipDownloadLink && clearSamplePayslip()

    const {name,value,checked} = event.target

    if (['consent'].includes(name)){

      setData({
        ...data,
        [name]: checked,
      })
    } if (['workedHours','salary','leaveHours','performanceBonus'].includes(name)){
      // calculate salary
      
      let hourlyRate = data.hourlyRate
      let monthlyRate = null

      if (['salary'].includes(name)){
      // calculate salary

        switch (value){
          case "10/hr":
            hourlyRate = 10
            break;
          case "1000/mo":
            hourlyRate = 5.77
            monthlyRate = 1000
            break;
          case "20000/yr":
            hourlyRate = 9.62
            monthlyRate = 1666.67
            break;
        }
      }

      let calcValue = value
      if (value == "" || value == null){
        calcValue = 0;
      }

      const workedHours = name == 'workedHours' ? parseFloat(calcValue) : data.workedHours || 0
      const leaveHours = name == 'leaveHours' ? parseFloat(calcValue) : data.leaveHours || 0

      const totalHours = parseFloat(workedHours) + parseFloat(leaveHours);
      const basicHours = Math.min(totalHours,173.33);
      const overtimeHours = parseFloat(Math.max(totalHours - basicHours,0).toFixed(2))
      const basicHoursValue = monthlyRate ? monthlyRate : parseFloat((basicHours * hourlyRate).toFixed(2))
      const vacationLeaveValue = parseFloat((leaveHours * hourlyRate).toFixed(2))
      const overtimeValue = parseFloat((overtimeHours * hourlyRate * 1.5).toFixed(2))

      const performanceBonus = parseFloat(data.performanceBonus) || 0

      console.log('data.totalHours',totalHours,basicHours,data.hourlyRate,basicHoursValue)

      setData({
        ...data,
        [name]: value,
        leaveHours,
        basicHours,
        basicHoursValue,
        vacationLeaveValue,
        overtimeHours,
        overtimeValue,
        hourlyRate,
        gross: (performanceBonus + parseFloat(basicHoursValue) + parseFloat(vacationLeaveValue) + parseFloat(overtimeValue)).toFixed(2)
      })
    } else {

      setData({
        ...data,
        [name]: value
      })
    }

  }

  const generateThatSamplePayslip = (e) => {
    numSchema.isValid({
      hours: data.leaveHours
    }).then(function(valid) {
      e.preventDefault();
      if(valid) {
        console.log('dataToSubmit',data)
        setLeaveErrorText("")
        if (!creatingPayslip){
          emailSchema.isValid({
            email: data.email
          }).then(function(valid) {
            e.preventDefault();
            if(valid) {
              if (!creatingPayslip){
                e.preventDefault();
                setEmailErrorText("")
                generateSamplePayslip({...data, country: country || "MT"})


                if (data.consent){

                  // const [data, setData] = useState({
                  //   noOfEmployees: "1-5",
                  //   name: "",
                  //   surname: "",
                  //   phone: "",
                  //   organisation: "",
                  //   email: "",
                  // });

                  // saveLead({ 
                  //   email: data.email,
                  //   list: country == "UK" ? 11 : 5
                  // })
                  addTag({
                    email: data.email,
                    tag: country == "UK" ? 58 : 59
                  })
                }

              }
            } else {
              setEmailErrorText("Invalid Email")
            }
          })
        }
      } else {
        setLeaveErrorText("Value too high")
      }
    })

  }

  const labelStyle = {
    lineHeight: "38px",
    marginTop: "4px"
  }

  return (

    <div className="relative bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden shadow-lg">
      <div className="px-4 py-8 sm:px-10">
        <div>
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Let's create a Payslip for Mario
          </h3>
          <div className="grid grid-cols-6 gap-3 mt-1 text-sm leading-5 text-gray-500">

            <div className="col-span-2" style={labelStyle}>
              Mario is paid
            </div>

            <div className="col-span-4">
              <select onChange={handleChange} name="salary" id="salary" className="rounded-md shadow-sm mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5">
                <option value="10/hr">{currencySign}10/hr (PT)</option>
                <option value="1000/mo">{currencySign}1000/mo (FT)</option>
                <option value="20000/yr">{currencySign}20000/yr (FT)</option>
              </select>
            </div>
          </div>
        </div>

        <div className="mt-6">
          <form onSubmit={generateThatSamplePayslip} className="space-y-6">


            <div className="grid grid-cols-6 gap-3 items-center">
              <div className="col-span-2">
                <label className="block text-sm font-medium leading-5 text-gray-700"></label>
              </div>

              <div className="col-span-2">
                <label className="block text-sm font-medium leading-5 text-gray-700">Quantity</label>
              </div>

              <div className="col-span-2">
                <label className="block text-sm font-medium leading-5 text-gray-700">Value</label>
              </div>

              <div className="col-span-2">
                <label style={labelStyle} className="block text-sm font-medium leading-5 text-gray-700">Worked Hours</label>
              </div>

              <div className="col-span-2">
                <input type="number" name="workedHours" id="workedHours" value={data.workedHours} onChange={handleChange} className="pl-1 h-8 rounded-md form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 border border-gray-300"/>
              </div>

              <div className="col-span-2">
                <label style={labelStyle} className="block text-sm font-medium leading-5 text-gray-700">{currencySign} {data.basicHoursValue}</label>
              </div>

              <div className="col-span-2">
                <label style={labelStyle} className="block text-sm font-medium leading-5 text-gray-700">Vacation Leave</label>
              </div>

              <div className="col-span-2">
                <input type="number" name="leaveHours" id="leaveHours" value={(data.leaveHours == 'Infinity' || data.leaveHours == 'NaN' ? 0 : data.leaveHours)} onChange={handleChange} className="pl-1 h-8 rounded-md form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 border border-gray-300"/>
                <p className="text-xs text-red-600" style={{marginBottom:"-1.2rem"}} id="email-error">
                  {leaveErrorText} 
                </p>
              </div>

              <div className="col-span-2">
                <label style={labelStyle} className="block text-sm font-medium leading-5 text-gray-700">{currencySign} {data.vacationLeaveValue}</label>
              </div>

              <div className="col-span-2">
                <label style={labelStyle} className="block text-sm font-medium leading-5 text-gray-700">Overtime</label>
              </div>

              <div className="col-span-2">
                <label style={labelStyle} className="block pl-1 text-sm font-medium leading-5 text-gray-700">{data.overtimeHours}</label>
              </div>

              <div className="col-span-2">
                <label style={labelStyle} className="block text-sm font-medium leading-5 text-gray-700">{currencySign} {data.overtimeValue}</label>
              </div>

              <div className="col-span-2">
                <label style={labelStyle} className="block text-sm font-medium leading-5 text-gray-700">Perf. Bonus</label>
              </div>

              <div className="col-span-2">
                <input type="number" name="performanceBonus" id="performanceBonus" value={data.performanceBonus} onChange={handleChange} className="pl-1 h-8 rounded-md form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 border border-gray-300"/>
              </div>

              <div className="col-span-2">
                <label style={labelStyle} className="block text-sm font-medium leading-5 text-gray-700">{currencySign} {data.performanceBonus}</label>
              </div>

            </div>


          </form>
        </div>
      </div>
      <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
      

          <div className="grid grid-cols-6 gap-3 items-center">
            <div className="col-span-4">
              <label className="block text-sm font-medium leading-5 text-gray-700">Gross Pay</label>
            </div>

            <div className="col-span-2">
              <label className="block text-sm font-medium leading-5 text-gray-700">{currencySign} {data.gross}</label>
            </div>

            <div className="col-span-2">
              <label style={labelStyle} className="block text-sm font-medium leading-5 text-gray-700">Email</label>
            </div>

            <div className="col-span-4">
              <input name="email" value={data.email} onChange={handleChange} className="rounded-md pl-2 h-8 mt-1 form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 border border-gray-300"/>
              <p className="text-xs text-red-600" style={{marginBottom:"-1.2rem"}} id="email-error">
                {emailErrorText} 
              </p>
            </div>
          </div>

          <div className="flex items-start mt-5">
            <div className="flex items-center h-5">
              <input value="yes" name="consent" onChange={handleChange} type="checkbox" className="rounded form-checkbox h-4 w-4 text-orange-500 transition duration-150 ease-in-out rounded-sm focus:ring-orange-500"/>
            </div>
            <div className="ml-3 text-sm leading-5">
              <p className="text-gray-500">I would like to recieve more information about Buddy.</p>
            </div>
          </div>

          <span className="block w-full rounded-md shadow-sm mt-4">

            {
              payslipDownloadLink && 
                <a href={payslipDownloadLink} className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                  Download Sample Payslip
                </a>
            }

            {
              !payslipDownloadLink &&
                <button onClick={generateThatSamplePayslip} type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                  { creatingPayslip &&
                    <React.Fragment>
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Generating Your Payslip
                    </React.Fragment>
                  }
                  { !creatingPayslip &&
                    `Send me a Sample Payslip`
                  }
                </button>
            }
          </span>

          <p className="mt-5 text-xs leading-5 text-gray-500">By signing up, you agree to our <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Terms</a>, <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Data Policy</a> and <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Cookies Policy</a>.</p>
      </div>
    </div>
    
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my

  const payslipSample = state && state.payslipSample

  return {
    creatingPayslip: payslipSample.creating,
    payslipDownloadLink: payslipSample.payslipDownloadLink,

  }
}

const mapDispatchToProps = dispatch => ({
  generateSamplePayslip: (data) => dispatch(PAYSLIPSAMPLEACTIONS.generateSamplePayslip(data)),
  clearSamplePayslip: () => dispatch(PAYSLIPSAMPLEACTIONS.clearSamplePayslip()),
  saveLead: (data) => dispatch(CREATEACCOUNTACTIONS.saveLead(data,'PayslipSample',6084250)),
  addTag: (data) => dispatch(CREATEACCOUNTACTIONS.addTag(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayslipSampleGenerator) 
